import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LazyLoad from 'react-lazyload';

import { Link } from 'shared/lib/SureDesignSystem';

import Logo from '../Logo';
import { ReactComponent as BuiltOnLogo } from 'shared/lib/assets/img/logo/logo-sure-built-on-sure.svg';
import NortonLogo from './assets/Seal_Symantec_Trans.svg';

import styles from './Footer.module.css';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

function currentYear() {
  return new Date().getFullYear();
}

function Footer({ className }) {
  return (
    <div className={classnames(styles.wrapper, className)}>
      <div className={styles.container}>
        <Link to="/" className={styles.logoWrapper}>
          <LazyLoad height={52} once>
            <Logo className={styles.logo} />
          </LazyLoad>
        </Link>
        <div className={styles.links}>
          <div className={styles.linksColumn}>
            <div className={styles.linksColumnItems}>
              <Link to="/insurance-products" className={styles.linksColumnItem}>
                Insurance Products
              </Link>
              <a
                className={styles.linksColumnItem}
                href="https://support.sureapp.com/hc/en-us"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support
              </a>
              <Link
                href="https://www.sureapp.com/company/about"
                className={styles.linksColumnItem}
              >
                About
              </Link>
              <Link to="/faq" className={styles.linksColumnItem}>
                FAQ
              </Link>
            </div>
          </div>
          <div className={styles.linksColumn}>
            <div className={styles.linksColumnItems}>
              <Link to="/login" className={styles.linksColumnItem}>
                Login
              </Link>
              <Link to="/login" className={styles.linksColumnItem}>
                Sign Up
              </Link>
              <Link
                href="https://www.sureapp.com"
                className={styles.linksColumnItem}
              >
                Visit Sure Platform
              </Link>
            </div>
          </div>
          <div className={styles.linksColumn}>
            <div className={styles.linksColumnItems}>
              <Link
                href="https://www.sureapp.com/terms-of-use"
                className={styles.linksColumnItem}
              >
                Terms and Conditions
              </Link>
              <Link
                href="https://www.sureapp.com/privacy-policy"
                className={styles.linksColumnItem}
              >
                Privacy Policy
              </Link>
              <Link to="/licenses" className={styles.linksColumnItem}>
                Licenses
              </Link>
            </div>
          </div>

          <div className={styles.linksColumn}>
            <div className={styles.linksColumnItems}>
              <span>
                Phone:{' '}
                <Link
                  href="tel:(844) 335-5441"
                  className={styles.linksColumnItem}
                >
                  (844) 335-5441
                </Link>
              </span>
              <span>
                Email:{' '}
                <Link
                  href="mailto:support@sureapp.com"
                  className={styles.linksColumnItem}
                  target="_blank"
                  rel="noopener nofollow"
                >
                  support@sureapp.com
                </Link>
              </span>
              <span>Mon - Fri | 8am - 5pm PST</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.copyrightWrapper}>
        <div className={styles.copyright}>
          © 2016-
          {currentYear()} Sure Inc. All rights reserved.
          <LazyLoad height={37} once>
            <img
              className={styles.norton}
              src={NortonLogo}
              alt="Norton by Symantec"
            />
          </LazyLoad>
        </div>
        <LazyLoad height={31} once>
          <BuiltOnLogo />
        </LazyLoad>
      </div>
    </div>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
